module.exports = __webpack_public_path__ + "static/robotMain_02-370f571ae7ad5c9c31bb14a3688f36a5.png";